const editPlanConsentTemplate = `
<div class="modal-header">
    <div class="modal-title">{{ "preference.eDelivery.modalheadline" | translate }}</div>
</div>
<div class="modal-body clearfix"  id="myModal" data-backdrop="static"  >

    <label><strong>{{ "preference.eDelivery.label.eDelivery" | translate }}</strong></label>

    <form  role='form'  name="eConsentForm"  data-ng-submit="updateParticipantConsent('registrationFlow')" novalidate >
        <div class="form-group">
 
            <div class="checkbox">
                <label>
                    <input type="checkbox" ng-model="vm.eConsent.pptInd"  name="pptInd" ng-true-value="'true'" ng-false-value="'false'"> {{vm.planName}}
                    <div> -- {{ "preference.eDelivery.label.documentsInclude" |translate }} {{vm.docTypes}}</div>
                </label>       
            </div>


        </div>

        <div class="form-group">
            <label for="emailChoice">{{ "preference.eDelivery.label.email" | translate }}</label>

            <select class="form-control" id="emailChoice" class="col-md-6" name="emailchoice" data-ng-model="vm.eConsent.emailchoice"    >
                <option ng-repeat="emailOption in vm.email" value="{{emailOption}}">{{emailOption}}</option>
            </select>
        </div>

        <div    class ="document-review" >
           <p ng-bind-html="'preference.eDelivery.legal.section' | translate"> </p>   
        </div>

        <div class="pull-right">
            <a ng-click="cancel()" class="btn btn-link">{{ "preference.button.cancel" | translate }}</a>
            <input type="submit" class="btn btn-primary" id="submit" translate="preference.button.save" /> 
        </div>
    </form>
</div>
`;
export default editPlanConsentTemplate;
